import { render } from "./HouseholdTab.vue?vue&type=template&id=1340a5b1"
import script from "./HouseholdTab.vue?vue&type=script&lang=js"
export * from "./HouseholdTab.vue?vue&type=script&lang=js"

import "./HouseholdTab.vue?vue&type=style&index=0&id=1340a5b1&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__